import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app/app-routing.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAuth } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment.local';

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes, withEnabledBlockingInitialNavigation()),
        //AuthService,
        //UserService,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideAuth({
            config: {
                authority: `https://cognito-idp.eu-central-1.amazonaws.com/${environment.cognitoUserPoolId}`,
                redirectUrl: window.location.origin,
                postLogoutRedirectUri: window.location.origin,
                clientId: environment.cognitoAppClientId,
                scope: 'email openid profile',
                responseType: 'code',
                unauthorizedRoute: '/403',
                autoCleanStateAfterAuthentication: true
            }
        }),
    ]
}).catch(err => console.error(err));
